export default __webpack_public_path__ + "static/media/gallery3.1005fbfd.png";